'use client'
import { GeoLocationSensorState } from '../hooks/useGeolocation'
import React, { useContext } from 'react'

export interface GeolocationContext extends GeoLocationSensorState {}

const GeolocationContext = React.createContext<GeolocationContext | undefined>(
  undefined
)

export const useGeolocationCtx = () => useContext(GeolocationContext)!

export const GeolocationProvider = ({
  children,
  ...value
}: {
  children: React.ReactNode
} & GeoLocationSensorState) => {
  return (
    <GeolocationContext.Provider value={value}>
      {children}
    </GeolocationContext.Provider>
  )
}
